var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.88477 35.8651L10.0548 27.8151L23.9648 25.3501L22.5898 32.6301L3.78477 38.4101L2.56977 37.8851L1.88477 35.8651Z",
    fill: "#CA2C31",
    stroke: "black",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4696 29.8797L2.59961 37.9397L9.12461 41.1197L19.0296 36.0647V33.6797L21.0546 28.2197L11.4696 29.8797Z",
    fill: "#A02422",
    stroke: "black",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4599 44.0749L28.1749 45.9349L24.1299 54.5099C24.1299 54.5099 27.6899 62.3949 27.8499 62.3949C28.0099 62.3949 30.0349 62.5549 30.0349 62.5549L37.2349 54.5049L39.0549 40.7549L32.4599 44.0749Z",
    fill: "#A02422",
    stroke: "black",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2501 50.42C28.2501 50.42 30.6351 49.935 32.3351 49.125C34.0351 48.315 36.1351 47.105 36.1351 47.105L35.3651 53.82L27.8401 62.385C27.8401 62.385 27.5451 62.02 26.2951 59.3C25.3001 57.13 24.9551 56.355 24.9551 56.355L28.2501 50.42Z",
    fill: "#CA2C31",
    stroke: "black",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7897 40.3299C15.7897 40.3299 12.9197 40.0899 9.77469 44.0649C6.90469 47.6949 5.55969 53.6049 5.03969 55.1249C4.51969 56.6449 3.27469 56.9549 3.68969 57.6499C4.10469 58.3449 5.89969 58.3049 8.11469 58.0299C10.3297 57.7549 12.2297 57.0599 12.2297 57.0599C12.2297 57.0599 12.1347 57.2999 11.8147 57.8199C11.6997 58.0049 11.2997 58.2699 11.3297 58.5449C11.3997 59.1999 17.0097 59.2149 21.4897 54.6049C26.3297 49.6299 23.9797 45.5499 23.9797 45.5499L15.7897 40.3299Z",
    fill: "#F7D74D",
    stroke: "black",
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6543 42.645C16.6543 42.645 13.5593 42.81 10.9993 46.785C8.4393 50.76 7.2493 55.365 7.4943 55.675C7.7343 55.985 12.5043 54.26 13.6493 54.605C14.4343 54.845 14.0293 55.64 14.2393 55.85C14.4143 56.025 16.4843 56.32 19.8343 52.69C23.1893 49.06 22.3943 43.96 22.3943 43.96L16.6543 42.645Z",
    fill: "#FBF0B4",
    stroke: "black",
    strokeWidth: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1749 37.2197C18.1749 37.2197 16.6199 38.6047 16.0649 39.3997C15.5099 40.1947 15.5099 40.2647 15.5449 40.5047C15.5799 40.7447 16.1549 43.3797 18.5499 45.6897C21.4899 48.5247 24.1149 48.9047 24.4949 48.9047C24.8749 48.9047 27.3999 46.0697 27.3999 46.0697L18.1749 37.2197Z",
    fill: "#858585",
    stroke: "black",
    strokeWidth: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0498 45.6199C25.0498 45.6199 27.5698 47.2749 31.7948 45.8549C37.5698 43.9149 41.8048 39.5749 47.0498 34.0949C52.1098 28.8049 56.3548 22.2399 56.3548 22.2399L53.3798 12.2749L25.0498 45.6199Z",
    fill: "#437687",
    stroke: "black",
    strokeWidth: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9951 40.1649L34.6901 38.0049L36.4301 38.2499C36.4301 38.2499 37.7551 38.8749 38.7301 39.3299C39.7051 39.7849 40.9601 40.1299 40.9601 40.1299L38.4851 42.2199C38.4851 42.2199 37.1351 41.7099 36.1501 41.2799C35.0401 40.7949 33.9951 40.1649 33.9951 40.1649Z",
    fill: "#3F545F",
    stroke: "black",
    strokeWidth: 0.5
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1599 8.06982C42.1599 8.06982 37.3499 10.8598 30.4549 17.3848C24.2399 23.2648 19.6349 28.5848 18.5199 33.1098C17.5899 36.8998 18.0849 39.1998 20.1999 41.6848C22.4349 44.3148 25.0549 45.6198 25.0549 45.6198C25.0549 45.6198 27.0249 45.6498 35.2449 39.3248C45.4999 31.4298 53.7149 18.2098 53.7149 18.2098L42.1599 8.06982Z",
    fill: "#005B38",
    stroke: "black",
    strokeWidth: 0.5
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0899 20.9199C52.0899 20.9199 47.9049 19.1349 44.9199 14.9699C41.9549 10.8349 42.1899 8.03991 42.1899 8.03991C42.1899 8.03991 44.6699 6.09491 50.2449 3.86991C53.9949 2.37491 59.0999 1.60991 60.7799 2.85491C62.4599 4.09991 59.6299 10.3449 59.6299 10.3449L54.4749 20.3249L52.0899 20.9199Z",
    fill: "#D83F22",
    stroke: "black",
    strokeWidth: 0.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0849 40.2C34.0849 40.2 30.4699 38.355 28.1699 35.73C23.8199 30.775 22.9199 25.335 22.9199 25.335L25.1049 22.77C25.1049 22.77 25.6499 28.55 30.3149 33.545C33.3549 36.8 36.5299 38.29 36.5299 38.29C36.5299 38.29 35.8949 38.825 35.2149 39.345C34.7799 39.68 34.0849 40.2 34.0849 40.2Z",
    fill: "#6896A5",
    stroke: "black",
    strokeWidth: 0.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3548 22.24C56.3548 22.24 58.5248 19.625 60.5798 13.73C63.4498 5.51002 60.9498 3.02002 60.9498 3.02002C60.9498 3.02002 60.1048 6.93002 57.1698 12.365C54.8148 16.72 51.9648 20.865 51.9648 20.865C51.9648 20.865 53.5348 21.57 54.3848 21.815C55.4548 22.125 56.3548 22.24 56.3548 22.24Z",
    fill: "#A02422",
    stroke: "black",
    strokeWidth: 0.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9044 34.8297C20.5544 35.4497 21.5394 34.7997 22.1844 33.2797C22.8344 31.7597 22.8244 30.9097 22.3244 30.5497C21.7044 30.0997 20.6644 31.0847 20.2094 31.9597C19.7094 32.9297 19.4144 34.3597 19.9044 34.8297Z",
    fill: "#B3E1EE",
    stroke: "black",
    strokeWidth: 0.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4747 10.0649C42.4747 10.0649 38.6697 12.7999 34.6097 16.5199C30.8847 19.9349 28.4147 22.6049 28.0747 23.2249C27.7147 23.8899 27.7097 24.8299 27.9897 25.3099C28.2697 25.7899 28.8897 26.0399 29.4547 25.6199C30.0197 25.1949 34.0447 20.7449 37.6797 17.5649C41.0047 14.6549 43.5697 12.8099 43.5697 12.8099C43.5697 12.8099 44.6097 10.9699 44.4397 10.5499C44.2697 10.1249 42.4747 10.0649 42.4747 10.0649Z",
    fill: "#B3E1EE",
    stroke: "black",
    strokeWidth: 0.5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4746 10.0648C42.4746 10.0648 45.2846 7.90978 48.3446 6.39478C51.1896 4.98478 54.0196 3.80978 54.5296 4.82978C55.0146 5.79978 51.8446 7.11978 49.0546 8.89978C46.2646 10.6798 43.5796 12.8048 43.5796 12.8048C43.5796 12.8048 43.1696 12.0548 42.9046 11.3598C42.7365 10.9367 42.5929 10.5043 42.4746 10.0648Z",
    fill: "#ED6A65",
    stroke: "black",
    strokeWidth: 0.5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7946 19.6251C42.0096 17.0601 38.1346 17.7501 36.2246 20.0301C34.2646 22.3801 34.4096 25.9701 36.7246 28.1301C38.8296 30.0901 42.7446 30.5351 45.1046 27.7851C47.2046 25.3451 47.0746 21.7201 44.7946 19.6251Z",
    fill: "#E1E1E1",
    stroke: "black",
    strokeWidth: 0.5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6652 20.9352C36.0102 22.5602 36.1002 25.7802 38.0702 27.2502C39.7902 28.5352 42.2302 28.4702 43.7602 26.9052C45.2902 25.3402 45.2902 22.4952 43.8552 21.0252C42.2052 19.3402 39.5602 19.0752 37.6652 20.9352Z",
    fill: "#3F545F",
    stroke: "black",
    strokeWidth: 0.5
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9998 38.4449C24.9998 38.4449 28.0948 35.3049 28.4348 35.6449C28.7748 35.9849 28.7298 37.8899 27.2498 40.0099C25.7648 42.1299 22.4998 45.9049 19.9148 48.4499C17.3648 50.9549 13.7698 53.8199 13.4298 53.7699C13.1648 53.7299 12.0898 53.1949 11.6598 52.6749C11.2398 52.1599 12.4948 49.7249 12.9998 48.9199C13.5098 48.1149 24.9998 38.4449 24.9998 38.4449Z",
    fill: "#A02524",
    stroke: "black",
    strokeWidth: 0.5
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6143 50.9248C10.5743 51.6448 11.6743 52.6948 11.6743 52.6948L28.4343 35.6498C28.4343 35.6498 27.6493 34.7648 25.3393 36.1998C23.0093 37.6498 20.9693 39.3898 17.9593 42.3048C13.7643 46.3748 10.6543 50.2048 10.6143 50.9248Z",
    fill: "#CA2C31",
    stroke: "black",
    strokeWidth: 0.5
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M9.53002 18.475C8.97502 19.03 8.95002 19.92 9.57002 20.43C10.12 20.885 11.015 20.59 11.35 20.18C11.685 19.77 11.645 18.88 11.2 18.44C10.755 17.995 9.87002 18.14 9.53002 18.475Z",
    fill: "#005B38",
    stroke: "black",
    strokeWidth: 0.5
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M20.5098 17.8249C20.0898 18.2899 20.2248 18.9799 20.6148 19.2349C21.0048 19.4899 21.5898 19.4649 21.8748 19.1149C22.1298 18.7999 22.1598 18.1699 21.7698 17.7799C21.4298 17.4449 20.7798 17.5249 20.5098 17.8249Z",
    fill: "#005B38",
    stroke: "black",
    strokeWidth: 0.5
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7747 5.94474C27.7747 5.94474 28.3847 4.20474 28.7447 4.18474C29.1097 4.16474 29.6347 5.92474 29.6347 5.92474C29.6347 5.92474 31.4397 5.94474 31.5597 6.20974C31.7147 6.54974 30.4047 7.68974 30.4047 7.68974C30.4047 7.68974 30.8297 9.38974 30.6297 9.59474C30.4047 9.81974 28.8497 8.92474 28.8497 8.92474C28.8497 8.92474 27.2497 10.0397 26.9047 9.73474C26.6047 9.46974 27.2297 7.66974 27.2297 7.66974C27.2297 7.66974 25.7297 6.57474 25.8097 6.26974C25.9247 5.83974 27.7747 5.94474 27.7747 5.94474Z",
    fill: "#005B38",
    stroke: "black",
    strokeWidth: 0.5
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5048 47.6649C49.1098 47.9999 49.8698 47.8099 50.1498 47.1649C50.4048 46.5899 49.9348 45.9049 49.5098 45.7199C49.0848 45.5349 48.3398 45.7799 48.0698 46.2649C47.8048 46.7449 48.1398 47.4649 48.5048 47.6649Z",
    fill: "#005B38",
    stroke: "black",
    strokeWidth: 0.5
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0949 32.92C56.7499 32.385 56.0049 32.21 55.5199 32.64C55.0499 33.06 55.1649 33.72 55.4299 34.055C55.6949 34.39 56.4049 34.515 56.8349 34.24C57.2649 33.965 57.3049 33.24 57.0949 32.92Z",
    fill: "#005B38",
    stroke: "black",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.7117e77b6765507d2cb726688bcf8fd8.svg";
export { ForwardRef as ReactComponent };